import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ 
  children, 
  adminOnly = false, 
  requiredPermission = null,
  requiredAnyPermission = null,
  requiredAllPermissions = null
}) => {
  const { isAuthenticated, user, loading, hasPermission, hasAnyPermission, hasAllPermissions, isAdmin } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/announcements" replace />;
  }

  // Check for single required permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <AccessDenied />;
  }

  // Check for any of multiple permissions
  if (requiredAnyPermission && !hasAnyPermission(requiredAnyPermission)) {
    return <AccessDenied />;
  }

  // Check for all of multiple permissions
  if (requiredAllPermissions && !hasAllPermissions(requiredAllPermissions)) {
    return <AccessDenied />;
  }

  return children;
};

// Access Denied Component
const AccessDenied = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    flexDirection: 'column'
  }}>
    <h2>Access Denied</h2>
    <p>You don't have permission to access this page.</p>
    <button 
      onClick={() => window.history.back()}
      style={{
        padding: '10px 20px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginTop: '10px'
      }}
    >
      Go Back
    </button>
  </div>
);

export default ProtectedRoute;